import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../../firebase";

interface Request {
  userId: string;
  email: string;
}

interface Response {
  success: boolean;
  message: string;
}

interface Props extends Request {

}

export const updateUserEmail = async (data: Props) => {
  const functions = getFirebaseFunctions();

  const updateUserEmail = httpsCallable<Request, Response, object>(
    functions,
    "admin_updateUserEmail",
  );

  try {
    const res = await updateUserEmail(data);
    return res.data;
  } catch (error) {
    console.error("Failed to update user email:", error);
    throw error;
  }
};
